import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "@/components/brand/Logo";
import { useLang } from "@/context/LangContext";

export default function Footer() {
  const { lang } = useLang();
  const year = new Date().getFullYear();
  const links = lang === "es"
    ? [
        { href: "/app/settings", label: "Ajustes" },
        { href: "/app/support", label: "Soporte" },
        { href: "/app/profile", label: "Cuenta" },
      ]
    : [
        { href: "/app/settings", label: "Settings" },
        { href: "/app/support", label: "Support" },
        { href: "/app/profile", label: "Account" },
      ];
  return (
    <footer
      data-testid="footer"
      className="border-t border-slate-800/80 mt-6 px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[11px] text-slate-500"
    >
      <div className="flex items-center gap-2.5">
        <LogoMark size={20} />
        <span>
          © {year} <span className="text-slate-300">Yosi Media Studio</span> — {lang === "es" ? "Sistema operativo para agencias digitales." : "Business Operating System for digital agencies."}
        </span>
      </div>
      <nav className="flex items-center gap-4">
        {links.map((l) => (
          <Link key={l.href} to={l.href} className="hover:text-white transition-colors">{l.label}</Link>
        ))}
        <span className="hidden sm:inline text-slate-700">·</span>
        <span className="hidden sm:inline text-slate-600">v0.4 · Rebranded</span>
      </nav>
    </footer>
  );
}
